import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../lib/api";

/* /r/b/:id            → legacy whole-blast click (no per-recipient detail)
 * /r/b/:id/:rid       → per-recipient click, marks `clicked_at` on the
 *                        blast_recipients row so opens vs clicks reporting
 *                        is deterministic.
 *
 * Both paths stash the blast id in localStorage so the eventual signup
 * can attribute via /api/blasts/track-signup.
 */
export default function BlastRedirect() {
  const { id, rid } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      let dest = "/";
      try {
        const url = rid ? `/blasts/${id}/r/${rid}/redirect` : `/blasts/${id}/redirect`;
        const r = await api.get(url);
        if (r.data?.slug) dest = `/promo/${r.data.slug}`;
        try { localStorage.setItem("tapintv:blast_id", id); } catch {}
        if (rid) { try { localStorage.setItem("tapintv:blast_rid", rid); } catch {} }
      } catch {
        // unknown blast — quietly send the user home
      }
      if (!cancelled) nav(dest, { replace: true });
    })();
    return () => { cancelled = true; };
  }, [id, rid, nav]);

  return (
    <div data-testid="blast-redirect" className="min-h-screen flex items-center justify-center text-white/60">
      Redirecting…
    </div>
  );
}
